import { Modal, notification } from 'antd';
import { tolgee } from '../App';
import { CheckCircleFilled } from '@ant-design/icons';

type ToastTypes =
  | 'previous-date'
  | 'fail-login'
  | 'add-to-cart-error'
  | 'event-reserved'
  | 'event-updated'
  | 'event-deleted'
  | 'success-login'
  | 'error_startdate'
  | 'session-expired'
  | 'order-placed'
  | 'order-updated'
  | 'voucher-success'
  | 'something-wrong'
  | 'permission-denied'
  | (string & {});

export const showToast = (
  keyName: ToastTypes,
  type: 'info' | 'error' | 'success',
  desc: string = '',
  placement:
    | 'topLeft'
    | 'top'
    | 'topRight'
    | 'bottom'
    | 'bottomLeft'
    | 'bottomRight' = 'topRight',
) => {
  const messageText = tolgee.t(keyName, keyName);
  const descText = desc.length ? tolgee.t(desc, desc) : undefined;

  switch (type) {
    case 'error':
      notification.error({
        message: messageText,
        description: descText,
        placement: placement,
      });
      break;
    case 'info':
      notification.info({
        message: messageText,
        description: descText,
        placement: placement,
      });
      break;
    case 'success':
      notification.success({
        message: messageText,
        description: descText,
        placement: placement,
        icon: <CheckCircleFilled style={{ color: '#7B9081' }} />,
      });
      break;
    default:
      console.log('default case');
  }
};

let navigateFunction: ((path: string) => void) | null = null;

export function setNavigateFunction(navigate: (path: string) => void) {
  navigateFunction = navigate;
}

export function navigateTo(path: string) {
  if (navigateFunction) {
    navigateFunction(path);
  } else {
    console.error('Navigate function not set!');
  }
}

export const openConfirmationPopup = ({
  title,
  onOkCB,
  onCancelCB,
  okText,
  cancelText,
}: {
  title: string;
  onOkCB?: Function;
  onCancelCB?: Function;
  okText?: any;
  cancelText?: any;
}) => {
  Modal.confirm({
    title: title,
    okText: okText,
    width: '30rem',
    className: 'light-title-modal',
    closable: true,
    okButtonProps: {
      style: {
        backgroundColor: '#275747',
        padding: '0.3rem 1.5rem',
        marginLeft: '1rem',
        borderRadius: '2.4rem',
      },
    },
    cancelButtonProps: {
      style: {
        backgroundColor: '#275747',
        color: '#fff',
        padding: '0.3rem 1.5rem',
        borderRadius: '2.4rem',
      },
    },
    cancelText,

    styles: {
      body: {
        backgroundColor: '#eff3ef',
        padding: '2rem 3.5rem',
        borderRadius: '2.4rem',
      },
      content: { padding: '0', backgroundColor: 'transparent' },
    },
    style: { padding: '0', backgroundColor: 'none' },
    onOk() {
      onOkCB?.();
    },
    onCancel() {
      onCancelCB?.();
    },
  });
};

export const getCompanyIds = (
  companyNames: string[],
  associatedCompanies: any,
) => {
  return associatedCompanies
    .filter((comp: any) =>
      companyNames.find((val: string) => val === comp.companyName),
    )
    .map((com: any) => com.companyId);
};

export const toggleItemInArray = <T,>(array: T[], item: T): T[] =>
  array.includes(item) ? array.filter(i => i !== item) : [...array, item];
